export const loaderLabel = bfTranslate('Loading');
